import HttpClient from "../base/http-client";

export default class AuthClient extends HttpClient {
    constructor() {
        super("");
    }
}
